import React, { Component } from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { GenericAlphaNumericInput } from 'web-ui-components/lib/data/capture';
import { BrandedPanel } from 'web-ui-components/lib/layout/content';
import { ValidationMessageTile } from 'web-ui-components/lib/layout/content';
import { StandardLabel } from 'web-ui-components/lib/typography/labels';
import { NavigationButtons } from '../NavigationButtons';
import {
  setCookie,
  removeCookie,
  getCookie,
  isStoreCodeValid,
  hasStoreCodeBeenSubmittedBefore
} from '../../utils';
import constants from '../../constants';

const { CHARACTER_COUNT, STORE_CODE_MIN_LENGTH, STORE_CODE_MAX_LENGTH } = constants;

const initialState = {
  storeCode: {
    isValid: false,
    value: '',
    validationErrorReason: ''
  },
  existingCookie: {},
  isLocked: false
};
export class StorePanel extends Component {
  constructor(props) {
    super(props);
    const {
      parsedParams: {
        queryParams: { branch_id: urlStoreCode = '' }
      },
      config: { cookieName },
      content: { storeCodeValidationMessage }
    } = this.props;

    this.state = {
      ...initialState,
      storeCode: {
        ...initialState.storeCode,
        value: urlStoreCode,
        isValid: isStoreCodeValid(urlStoreCode),
        validationErrorReason:
          !isStoreCodeValid(urlStoreCode) && urlStoreCode !== '' ? storeCodeValidationMessage : ''
      },
      existingCookie: getCookie(cookieName) || {}
    };
    this.handleResetPanel = this.handleResetPanel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStoreCodeOnChange = this.handleStoreCodeOnChange.bind(this);
  }
  componentDidMount() {
    const {
      storeCode: { isValid },
      existingCookie
    } = this.state;
    const {
      parsedParams: { brandParam }
    } = this.props;

    if (isValid && !hasStoreCodeBeenSubmittedBefore(existingCookie, brandParam)) {
      this.handleSubmit();
    }
  }

  handleStoreCodeOnChange = data => {
    const { storeCode } = this.state;
    this.setState({
      storeCode: {
        ...storeCode,
        value: data.value,
        validationErrorReason: '',
        isValid: isStoreCodeValid(data.value)
      }
    });
  };

  handleResetPanel = () => {
    this.setState({ ...initialState });
    const {
      config: { cookieName },
      handleResetStore
    } = this.props;
    removeCookie(cookieName);
    handleResetStore();
  };

  handleSubmit = () => {
    const {
      storeCode,
      storeCode: { value, isValid }
    } = this.state;
    const {
      content: { storeCodeValidationMessage }
    } = this.props;

    if (!isValid) {
      return this.setState({
        storeCode: { ...storeCode, validationErrorReason: storeCodeValidationMessage }
      });
    }

    const {
      parsedParams: { brandParam },
      config: { cookieName },
      handleRedirectToBrochureware
    } = this.props;

    const branchDetails = {
      storeCode: value,
      bankId: brandParam
    };
    setCookie(cookieName, branchDetails);
    this.setState(
      {
        storeCode: { ...storeCode, validationErrorReason: '' },
        isLocked: true
      },
      () => handleRedirectToBrochureware()
    );
  };

  render() {
    const {
      isLocked,
      storeCode: { value, validationErrorReason, isValid }
    } = this.state;
    const {
      config: { isA2HSFeatureEnabled },
      content: { brandedPanelTitle, branchCodeLabel, resetButtonLabel, a2hsButtonLabel }
    } = this.props;

    return (
      <BrandedPanel title={brandedPanelTitle}>
        <StandardBody isFlush>
          <StandardLabel>
            <span>{branchCodeLabel}</span>
          </StandardLabel>
          {!isValid && validationErrorReason && (
            <ValidationMessageTile messageText={validationErrorReason} />
          )}
          <GenericAlphaNumericInput
            hasValidationEnabled
            id="generic-alpha-numeric-input-1"
            characterCount={CHARACTER_COUNT}
            maxLength={STORE_CODE_MAX_LENGTH}
            minLength={STORE_CODE_MIN_LENGTH}
            onChange={this.handleStoreCodeOnChange}
            value={value}
          />
          <NavigationButtons
            isValid={isValid}
            isLocked={isLocked}
            isA2HSFeatureEnabled={isA2HSFeatureEnabled}
            resetLabel={resetButtonLabel}
            a2hsLabel={a2hsButtonLabel}
            handleReset={this.handleResetPanel}
            handleSubmit={this.handleSubmit}
            handleA2HS={() => alert('This webpage will be added to your device home screen')}
          />
        </StandardBody>
      </BrandedPanel>
    );
  }
}
